export type RootLoaderData = Record<string, never>

export const loader = async () => {
  if (!window.publicClient || !window.blockNumber) {
    await window.domain.InitPublicClientEthereumUseCase.execute()
  }

  return {}
}
